import { post, postWithAuthentication } from '@/services/api'
import * as types from './mutation-types'
import { BASE_URL, LOGIN_API_ENDPOINT, LOGOUT_API_ENDPOINT } from '@/assets/constants/api_endpoints'
import { StorageService } from '@/services/StorageService'

export default {
    async login({ commit }, data) {
        await postWithAuthentication(BASE_URL, LOGIN_API_ENDPOINT, data.user)
        .then((res) => {
            commit(types.LOGIN, res)
        })
        .catch(error => { throw error })
    },
    async logout({ commit }) {
        return postWithAuthentication(BASE_URL, LOGOUT_API_ENDPOINT)
        .then(() => {
            commit(types.LOGOUT, { token: null, userId: null })
        })
        .catch(error => { throw error })
    },
    async initializeAuth({ commit }) {
        // Initialize auth state from localStorage on app startup
        const token = StorageService.getAuthToken()
        if (token) {
            commit(types.LOGIN, { token })
        }
    }
}